import React from 'react';
import { Button } from './ui/button';
import { Sparkles, Calendar, MapPin } from 'lucide-react';

const AFRO_IMG = 'https://images.unsplash.com/photo-1529348915581-73628f0cf212?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';

const AfroNation2027 = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const sendMail = () => {
    const subject = encodeURIComponent('Information — Cap-Vert 2027 · Afro Nation');
    const body = encodeURIComponent(
      'Bonjour Samantha,\n\nJe souhaite avoir des informations sur le prochain voyage Cap-Vert 2027 (Afro Nation).\n\nMerci ! 💛'
    );
    window.location.href = `mailto:flyoutbysam@gmail.com?subject=${subject}&body=${body}`;
  };

  return (
    <section
      id="afronation-2027"
      data-testid="afronation-2027-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-28 pb-16"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${AFRO_IMG})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-charcoal-dark/90 via-charcoal/80 to-gold-900/60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-cream-100">
        <p className="girls-only-anim text-2xl md:text-4xl font-semibold tracking-[0.3em] text-gold-300 uppercase mb-3">
          Girls Only
        </p>
        <p className="text-xs md:text-sm font-light text-cream-100/70 max-w-xl mx-auto mb-10 leading-relaxed">
          Nous ne diffusons pas toutes les photos de nos voyages : cela reste confidentiel.
          <br />
          Avec Fly, tes secrets sont bien gardés. 🤫
        </p>

        <div className="prochain-anim inline-flex items-center gap-3 mb-8 px-10 py-5 bg-gold-500/20 backdrop-blur-md border border-gold-300/50 rounded-full shadow-2xl">
          <Sparkles className="w-7 h-7 text-gold-300" />
          <span className="text-xl md:text-2xl tracking-[0.25em] text-gold-100 uppercase font-medium">Prochain voyage</span>
        </div>

        <p className="text-xl md:text-2xl font-light tracking-[0.3em] text-gold-200 mb-4 uppercase">Cap-Vert</p>

        <h1 className="text-7xl md:text-8xl font-light mb-2 leading-none">
          <span className="bg-gradient-to-r from-gold-200 via-gold-300 to-gold-400 bg-clip-text text-transparent">2027</span>
        </h1>

        <p className="afro-anim text-5xl md:text-6xl font-light italic mb-10 text-cream-100">Afro Nation</p>

        <div className="flex flex-wrap justify-center gap-8 mb-10 text-cream-100/80">
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-gold-300" />
            <span className="font-light">Île de Sal, Cap-Vert</span>
          </div>
          <div className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-gold-300" />
            <span className="font-light">Été 2027</span>
          </div>
        </div>

        <div className="inline-block mb-10 px-10 py-4 bg-cream-100/5 backdrop-blur-md border border-gold-300/30 rounded-full">
          <p className="text-lg md:text-xl font-light tracking-wide text-gold-100">
            ✨ Plus d'infos très bientôt ✨
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            data-testid="afronation-notify-btn"
            onClick={scrollToContact}
            size="lg"
            className="bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-500 hover:to-gold-600 text-charcoal px-12 py-6 text-lg font-medium rounded-full shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Être informée en priorité
          </Button>
          <Button
            data-testid="afronation-mail-btn"
            onClick={sendMail}
            size="lg"
            variant="outline"
            className="bg-transparent border-2 border-gold-300/70 text-gold-100 hover:bg-gold-300/10 hover:border-gold-200 px-12 py-6 text-lg font-medium rounded-full transition-all duration-300 hover:scale-105"
          >
            Envoyer un mail
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AfroNation2027;
